<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.combo"
    item-text="nomeCombo"
    item-name="nomeCombo"
    item-value="municipioPropostaCombosId"
    :items="combos"
    label="Pacote"
    hide-details="auto"
    placeholder="Selecione o pacote"
    v-on:change="$emit('onChange', filter.combo)"
    :clearable="true"
    :return-object="true"
  >
    <template slot="no-data"> Nenhum Pacote retornado </template>
  </v-select>
</template>

<script>
import { municipioPropostaComboApi } from "@/apis";
export default {
  name: "ComboboxCombosMT",
  props: ["filter"],
  mounted() {
    this.load();
  },
  methods: {
    load() {
      municipioPropostaComboApi
        .list()
        .then((resp) => {
          this.combos = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      combos: [],
    };
  },
};
</script>
